import { useState, type DragEvent } from "react";

/** D&D natif HTML5 minimal — un id traîné, une cible survolée.
 * ponytail: pas de dataTransfer ni de lib, un state suffit pour du D&D interne. */
export function useDrag() {
  const [dragId, setDragId] = useState<string | null>(null);
  const [overKey, setOverKey] = useState<string | null>(null);

  const dragProps = (id: string) => ({
    draggable: true,
    onDragStart: () => setDragId(id),
    onDragEnd: () => {
      setDragId(null);
      setOverKey(null);
    },
  });

  const dropProps = (
    key: string,
    onDrop: (id: string) => void,
    enabled = true,
  ) => ({
    onDragOver: (e: DragEvent) => {
      if (!enabled || !dragId) return;
      e.preventDefault();
      setOverKey(key);
    },
    onDragLeave: () => setOverKey((k) => (k === key ? null : k)),
    onDrop: (e: DragEvent) => {
      e.preventDefault();
      if (enabled && dragId) onDrop(dragId);
      setDragId(null);
      setOverKey(null);
    },
  });

  return { dragId, overKey, dragProps, dropProps };
}
